import styled from 'styled-components'
import colors from '../../styles/colors'
import mediaQuery from 'styles/mediaQuery'

export const Title = styled.h1`
  font-weight: 700;
  line-height: 1;
  margin-bottom: 24px;
  font-size: 36px;

  ${mediaQuery.bigTabletMin} {
    font-size: 80px;
  }
`

export const Subtitle = styled.h2`
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 24px;
  position: relative;
  display: inline-block;
  padding-left: 1.75rem;
  font-size: 20px;

  ${mediaQuery.bigTabletMin} {
    font-size: 24px;
  }

  &:before {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    content: '';
    background-color: ${colors.purple};
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
  }
`

export const Text = styled.h2`
  font-weight: 500;
  color: #43464d;
  line-height: 1.5;
  margin-bottom: 24px;
  font-size: 18px;

  ${mediaQuery.bigTabletMin} {
    font-size: 24px;
  }
`

export const PurpleText = styled.span`
  color: ${colors.purple};
`
